import '@fullcalendar/core/main.css';
import '@fullcalendar/daygrid/main.css';
import '@fullcalendar/timegrid/main.css';
import classNames from 'classnames';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import './App.scss';
import AADService from './components/Azure/AADService';
import AxiosConexionConfig from './components/Conexion/AxiosConexionConfig';
import AppMenu from './components/LayoutComponents/AppMenu';
import AppProfile from './components/LayoutComponents/AppProfile';
import AppTopbar from './components/LayoutComponents/AppTopbar';
import Routes from './components/LayoutComponents/Routes';
import Loadding from './components/Loadding';
import NoConexion from './components/NoConexion';
import {
  apiGetPlantas,
  apiPing,
  apiUsuarioMe,
  LayoutLg,
  LayoutMd,
  LayoutSm,
  localStorageBoard,
  rutaIndex,
  widges,
} from './Config/const';
import './layout/layout.scss';
import {
  setConfigurationPlantas,
  setPlantaActual,
  setPlantas,
  setUserDataFromLocalStorage,
} from './store/actions/proyectAction';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lenguage: this.props.global.idioma,
      frequency: 60,
      defaultBoardLayout: false,
      enerlandPanel: this.EnerlandPanel(),
      layoutMode: 'static',
      layoutColorDark: true,
      layoutColorMode: 'light',
      layoutColorText: 'Change to light',
      staticMenuInactive: false,
      overlayMenuActive: false,
      mobileMenuActive: false,
      refreshKey: true,
      ripple: false,
      refreshInterval: this.LoadIntervalRefresh(),
      cantDias: this.LoadCantDias(),
      AzureADService: null,
      panel: {},
      load: true,
      loading: true,
      menu: [
        {
          label: this.props.t('Plantas'),
          icon: 'pi pi-fw pi-map-marker',
          to: '/map',
        },
      ],
      widges: widges,
      loadProfile: false,
    };
    this.onToggleMenu = this.onToggleMenu.bind(this);
    this.onSidebarClick = this.onSidebarClick.bind(this);
    this.onMenuItemClick = this.onMenuItemClick.bind(this);
    this.AzureADService = new AADService();
    this.handleConexioApi();
    this.datos();
  }

  componentDidMount() {
    document.title = this.props.t('Title'); //TÍTULO DE LA PÁG WEB
  }

  datos = async () => {
    if (this.AzureADService.getToken() === null) {
      this.AzureADService.acquireToken();
    }
    const user = this.AzureADService.getUser();
    const requestOptions = encodeURIComponent(
      JSON.stringify({
        include: [
          {
            relation: 'plantas',
            scope: {
              fields: [
                'idplanta',
                'nombre',
                'direccion',
                'pais',
                'tipo',
                'latitud',
                'longitud',
                'potenciapico',
                'probjetivo',
                'mwtotal',
                'idGpm',
              ],
            },
          },
        ],
      }),
    );
    try {
      const url = apiUsuarioMe + `?filter=${requestOptions}`;

      const urlPlantasConfiguracion =
        apiGetPlantas + '?filter[fields][imagen]=false';

      const [usuario, plantas] = await Promise.all([
        AxiosConexionConfig.get(url),
        AxiosConexionConfig.get(urlPlantasConfiguracion),
      ]);

      this.setUsuarioLocal(usuario.data, user);

      let configuracionMenu = {
        label: 'Configuracion',
        icon: 'pi pi-fw pi-cog',
        to: 'config',
      };

      this.props.setConfigurationPlantas(plantas.data);

      let menuTemporal = [];

      menuTemporal = this.datosPlantasMarcadores(usuario.data.plantas);

      this.props.setPlantas(menuTemporal);

      menuTemporal !== undefined && menuTemporal[0] !== undefined
        ? this.props.setPlantaActual(menuTemporal[0])
        : this.props.setPlantaActual(null);

      menuTemporal.push(configuracionMenu);

      const menuItems = [...this.state.menu, ...menuTemporal];

      this.setState({ menu: menuItems, loading: false });
    } catch (e) {
      console.log(e);
    }
  };

  setUsuarioLocal = (usuarioApi, usuarioAzure) => {
    const usuario = {
      userName: usuarioAzure.userName,
      name: usuarioAzure.profile.name,
      given_name: usuarioAzure.profile.given_name,
      family_name: usuarioAzure.profile.family_name,
      roles: usuarioApi.rol,
      isWriter: this.AzureADService.isInRole('Writer') ? 'yes' : 'no',
      isContributor: this.AzureADService.isInRole('Contributor') ? 'yes' : 'no',
      token: this.AzureADService.getToken(),
    };
    this.props.setUserDataFromLocalStorage(usuario);
    this.setState({ loadProfile: !this.state.loadProfile });
  };

  emptyPanel = () => {
    return {
      cantDias: '1',
      refreshInterval: '5000',
    };
  };
  EnerlandPanel = () => {
    const EnerlandPanel = localStorage.getItem(localStorageBoard);
    const panel =
      EnerlandPanel === null ||
      EnerlandPanel === undefined ||
      EnerlandPanel === 'undefined'
        ? this.emptyPanel()
        : JSON.parse(EnerlandPanel);
    return panel;
  };
  LoadIntervalRefresh = () => {
    const panel = this.EnerlandPanel();
    if (
      panel.refreshInterval === null ||
      panel.refreshInterval === undefined ||
      panel.refreshInterval === 'undefined'
    ) {
      panel.refreshInterval = '5000000';
    }
    //return (panel.refreshInterval);
    return '5000000';
  };
  LoadCantDias = () => {
    const panel = this.EnerlandPanel();
    if (
      panel.cantDias === null ||
      panel.cantDias === undefined ||
      panel.cantDias === 'undefined'
    ) {
      panel.cantDias = '1';
    }
    return panel.cantDias;
  };
  handleChangeLanguage = language => {
    this.setState(prevState => ({ lenguage: language }));
    // this.props.setIdioma(language);
    this.props.i18n.changeLanguage(language);
  };

  restoreBoard = value => {
    let panel = this.emptyPanel();
    this.setState({
      enerlandPanel: panel,
      cantDias: panel.cantDias,
      //refreshInterval:panel.refreshInterval,
      refreshKey: Math.random(),
      defaultBoardLayout: value,
    });
    const serializedPanel = JSON.stringify(panel);
    localStorage.setItem('localStorageBoard', serializedPanel);
    const serializedPanels = JSON.stringify({
      lg: LayoutLg,
      md: LayoutLg,
      sm: LayoutMd,
      xs: LayoutMd,
      xxs: LayoutSm,
    });
    localStorage.setItem('EnerlandBoardPanels', serializedPanels);
  };

  setCantDias = value => {
    let panel = this.EnerlandPanel();
    panel.cantDias = value;
    const serializedPanel = JSON.stringify(panel);
    localStorage.setItem(localStorageBoard, serializedPanel);
    this.setState({
      enerlandPanel: panel,
      cantDias: value,
      refreshKey: Math.random(),
    });
  };

  refreshPanel = () => {
    this.setState({
      refreshKey: Math.random(),
    });
  };

  onToggleMenu(event) {
    this.menuClick = true;

    if (this.isDesktop()) {
      if (this.state.layoutMode === 'overlay') {
        this.setState({
          overlayMenuActive: !this.state.overlayMenuActive,
        });
      } else if (this.state.layoutMode === 'static') {
        this.setState({
          staticMenuInactive: !this.state.staticMenuInactive,
        });
      }
    } else {
      const mobileMenuActive = this.state.mobileMenuActive;
      this.setState({
        mobileMenuActive: !mobileMenuActive,
      });
    }
    this.setState({ refreshKey: !this.state.refreshKey });
    event.preventDefault();
  }

  onSidebarClick(event) {
    this.menuClick = true;
  }

  onMenuItemClick(event) {
    if (!event.item.items) {
      this.setState({
        overlayMenuActive: false,
        mobileMenuActive: false,
      });
    }
  }

  isDesktop() {
    return window.innerWidth > 1024;
  }

  datosPlantasMarcadores(marcadores) {
    let menuTemp = [];
    marcadores.forEach(function (marcador, index) {
      menuTemp.push({
        nombre: marcador.nombre,
        label: marcador.nombre,
        idplanta: marcador.idplanta,
        icon: 'pi pi-fw pi-chart-line',
        to: 'plant' + index,
        position: marcador.position,
        direccion: marcador.direccion,
        latitud: marcador.latitud,
        longitud: marcador.longitud,
        pais: marcador.pais,
        probjetivo: marcador.probjetivo,
        tipo: marcador.tipo,
        text: marcador.nombre,
        pico: marcador.potenciapico,
        imagen: marcador.imagen,
        link: 'plant' + index,
      });
    });
    return menuTemp;
  }

  async handleConexioApi() {
    const url = apiPing;
    try {
      const ping = await AxiosConexionConfig.get(url);
      if (ping.status === 200) {
        this.setState({ load: true });
      } else {
        this.setState({ load: false });
      }
    } catch (e) {
      console.log(e);
      this.setState({ load: false });
    }
  }

  render() {
    //console.log("app")
    const logo =
      this.state.layoutColorMode === 'dark'
        ? 'assets/layout/images/logo-white.svg'
        : 'assets/layout/images/logo.svg';
    const wrapperClass = classNames('layout-wrapper', {
      'layout-overlay': this.state.layoutMode === 'overlay',
      'layout-static': this.state.layoutMode === 'static',
      'layout-static-sidebar-inactive':
        this.state.staticMenuInactive && this.state.layoutMode === 'static',
      'layout-overlay-sidebar-active':
        this.state.overlayMenuActive && this.state.layoutMode === 'overlay',
      'layout-mobile-sidebar-active': this.state.mobileMenuActive,
    });

    const sidebarClassName = classNames('layout-sidebar', {
      'layout-sidebar-dark': this.state.layoutColorMode === 'dark',
      'layout-sidebar-light': this.state.layoutColorMode === 'light',
    });
    //console.log(this.state.refreshKey+this.state.defaultBoardLayout)
    const loadApiOk = () => {
      return (
        <div className={wrapperClass}>
          <AppTopbar
            onToggleMenu={this.onToggleMenu}
            logo={logo}
            key={this.props.plantasVisibles ? 1 : 2}
            handleChangeLanguage={this.handleChangeLanguage.bind(this)}
            restoreBoard={this.restoreBoard.bind(this)}
            refreshCantDias={this.setCantDias.bind(this)}
            cantDiasValue={this.state.cantDias}
            refreshPanel={this.refreshPanel.bind(this)}
          />
          <div
            ref={el => (this.sidebar = el)}
            className={sidebarClassName}
            onClick={this.onSidebarClick}
          >
            <div className="layout-logo">
              <NavLink
                activeClassName="active-route"
                to={rutaIndex}
                exact={true}
              >
                <img
                  alt="Logo"
                  style={{ width: '60%', cursor: 'pointer' }}
                  src="assets/layout/images/Logo_Enerland_1.png"
                />
              </NavLink>
            </div>
            <AppProfile key={this.state.loadProfile} />
            <AppMenu
              model={this.state.menu}
              onMenuItemClick={this.onMenuItemClick}
              key={this.props.plantasVisibles ? 3 : 4}
              restoreBoard={this.restoreBoard.bind(this)}
            />
          </div>
          <Routes
            key={
              this.state.refreshKey +
              this.state.defaultBoardLayout +
              this.state.staticMenuInactive
            }
            layoutColorDark={this.state.layoutColorMode}
            reloadLayout={this.state.defaultBoardLayout}
            restoreBoard={this.restoreBoard.bind(this)}
            refreshInterval={this.state.refreshInterval}
            staticMenuInactive={this.state.staticMenuInactive}
            layoutMode={this.state.layoutMode}
            cantDias={this.state.cantDias}
          />
          <div className="layout-mask"></div>
        </div>
      );
    };

    const respuesta = () => {
      if (this.state.loading) {
        return <Loadding />;
      } else {
        if (this.state.load) {
          return loadApiOk();
        } else {
          return <NoConexion />;
        }
      }
    };
    return respuesta();
  }
}

const mapStateToProps = rootReducer => {
  return { global: rootReducer.proyect };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setConfigurationPlantas,
      setUserDataFromLocalStorage,
      setPlantas,
      setPlantaActual,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation('translations')(App));
